import { Product, ProductList, ProductView, ProductNew, ProductEdit, ProductInquiry } from '@/components/Product';

export default {
  path: '/product/',
  component: Product,
  meta: {
    text: '製品情報',
  },

  children: [
    {
      path: '',
      redirect: 'list',
    },
    {
      path: 'list',
      component: ProductList,
      meta: {
        text: '一覧',
      },
    },
    {
      path: 'view/:id',
      component: ProductView,
      meta: {
        text: '詳細',
      },
    },
    {
      path: 'new',
      component: ProductNew,
      meta: {
        text: '新規登録',
      },
    },
    {
      path: 'edit/:id',
      component: ProductEdit,
      meta: {
        text: '編集',
      },
    },
    {
      path: 'inquiry/:id',
      component: ProductInquiry,
      meta: {
        text: '問い合わせ',
      },
    },
  ],
};
